import { ModalContext } from "app/app";
import axios from "axios";
import { FieldInput } from "components/fieldInput";
import { ViewContext } from "components/lib";
import { Form, Formik } from "formik";
import { Fragment, useContext, useState } from "react";
import Loader from "./images/loader.gif";
import styles from "./styles.module.scss";

export function RequestedBindModal(props) {
  const context = useContext(ViewContext);
  const { modal, setModal } = useContext(ModalContext);
  const [loading, setLoading] = useState(false);

  const options = [
    {
      value: "submitted",
      label: "Submitted",
    },
    {
      value: "rejected",
      label: "Rejected",
    },
    {
      value: "bound",
      label: "Bound",
    },
  ];

  return (
    <Fragment>
      {modal.name === "requestedbind_modal" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div className={styles.title}>Edit Requested Bind Status</div>
              <div className={styles.line} />
              <Formik
                initialValues={{
                  status: options[0].value,
                }}
                onSubmit={async (values, { setErrors }) => {
                  setLoading(true);

                  const response = await axios.get(
                    "/api/quote/info/" + modal.data["Submission Number"]
                  );

                  const CWstatus = response.data.data.submissionStatus.status;

                  switch (values.status) {
                    case "bound":
                      if (CWstatus === "Bound") {
                        await axios
                          .patch("/api/quote/" + modal.data.id, {
                            policy: true,
                            status: "bound",
                          })
                          .then((r) => {
                            setModal({});
                            setLoading(false);

                            context.notification.show(
                              "Quote updated successfully!",
                              "success",
                              true,
                              "toast",
                              "check-circle"
                            );

                            modal.action();
                          })
                          .catch((err) => {
                            setModal({});
                            setLoading(false);

                            context.notification.show(
                              "Failed to update quote status!",
                              "error",
                              true,
                              "toast",
                              "check-circle"
                            );
                          });
                      } else {
                        setErrors({
                          status: `You can't update this quote as Bound, Cover Whale returned status: ${CWstatus}`,
                        });
                      }
                      break;

                    case "rejected":
                      if (CWstatus === "Rejected") {
                        await axios
                          .patch("/api/quote/" + modal.data.id, {
                            status: "rejected",
                          })
                          .then((r) => {
                            setModal({});
                            setLoading(false);

                            context.notification.show(
                              "Quote updated successfully!",
                              "success",
                              true,
                              "toast",
                              "check-circle"
                            );

                            modal.action();
                          })
                          .catch((err) => {
                            setModal({});
                            setLoading(false);

                            context.notification.show(
                              "Failed to update quote status!",
                              "error",
                              true,
                              "toast",
                              "check-circle"
                            );
                          });
                      } else {
                        setErrors({
                          status: `You can't update this quote as Rejected, Cover Whale returned status: ${CWstatus}`,
                        });
                      }
                      break;

                    case "submitted":
                      if (CWstatus === "Quoted") {
                        await axios
                          .patch("/api/quote/" + modal.data.id, {
                            status: "submitted",
                          })
                          .then((r) => {
                            setModal({});
                            setLoading(false);

                            context.notification.show(
                              "Quote updated successfully!",
                              "success",
                              true,
                              "toast",
                              "check-circle"
                            );

                            modal.action();
                          })
                          .catch((err) => {
                            setModal({});
                            setLoading(false);

                            context.notification.show(
                              "Failed to update quote status!",
                              "error",
                              true,
                              "toast",
                              "check-circle"
                            );
                          });
                      } else {
                        setErrors({
                          status: `You can't update this quote as Submitted, Cover Whale returned status: ${CWstatus}`,
                        });
                      }
                      break;

                    default:
                      if (CWstatus === "Quoted") {
                        await axios
                          .patch("/api/quote/" + modal.data.id, {
                            status: "submitted",
                          })
                          .then((r) => {
                            setModal({});
                            setLoading(false);

                            context.notification.show(
                              "Quote updated successfully!",
                              "success",
                              true,
                              "toast",
                              "check-circle"
                            );

                            modal.action();
                          })
                          .catch((err) => {
                            setModal({});
                            setLoading(false);

                            context.notification.show(
                              "Failed to update quote status!",
                              "error",
                              true,
                              "toast",
                              "check-circle"
                            );
                          });
                      } else {
                        setErrors({
                          status: `You can't update this quote as Submitted, Cover Whale returned status: ${CWstatus}`,
                        });
                      }
                      break;
                  }

                  if (values.status === "bound") {
                  }

                  setLoading(false);

                  /*  */
                }}
              >
                {({
                  errors,
                  touched,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  submitForm,
                }) => (
                  <Fragment>
                    <Form className={styles.form} onSubmit={handleSubmit}>
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="status"
                          type="select"
                          label="Status"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          required
                          options={options}
                          showErrors
                          errors={errors.status}
                          touched={touched.status}
                        />
                      </div>
                    </Form>
                    <div
                      className={styles.footer}
                      style={{ justifyContent: "flex-end" }}
                    >
                      <div className={styles.buttons}>
                        <button
                          className={styles.cancel}
                          onClick={() => setModal("")}
                        >
                          Cancel
                        </button>
                        <button className={styles.save} onClick={submitForm}>
                          {loading ? (
                            <img
                              src={Loader}
                              alt="Loader"
                              className={styles.loader}
                            />
                          ) : (
                            "Save"
                          )}
                        </button>
                      </div>
                    </div>
                  </Fragment>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
